import React from "react";
import { PanelAddUser } from "../../../UI/Users/Add/PanelAddUser";

const AddUser = () => {
  return (
    <div>
      <PanelAddUser />
    </div>
  );
};

export default React.memo(AddUser);
